<div id="div1" class="flex-row">
  <video
    width="100%"
    height="82%"
    [controls]="false"
    id="video"
    #video
    preload="auto"
    seekable="true"
    [attr.webkit-playsinline]="isIOS"
    [attr.playsinline]="isIOS"
    crossorigin
    (timeupdate)="updateProgress($event)"
    (loadedmetadata)="onMetadataLoaded()"
    (loadstart)="onLoadStart()"
    (canplaythrough)="onCanPlayThrough()"
    [ngStyle]="{ display: useCanvas ? 'none' : 'visible' }"
  >
    <source id="videoSource" #source type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  <div id="bigCanvasContainer">
    <canvas #canvas id="bigCanvas" [hidden]="!useCanvas"></canvas>
    <ng-content select="[videoOverlay]"></ng-content>
  </div>

  <div *ngIf="!isMobile" class="video-selection-overlay-container">
    <ts-media-source-selection
      *ngIf="showVideoSelectionOverlay$ | async"
      [sources]="sources"
      [selectedIndex]="selectedIndex"
      (sourceSelected)="selectVideo($event)"
    >
    </ts-media-source-selection>
  </div>

  <div id="videoBar" #videoBar class="d-flex" style="align-items: center">
    <!-- Playback Controls -->
    <button
      id="btn-stop"
      mat-icon-button
      class="btn"
      (click)="stop()"
      matTooltip="{{ 'button.stop' | translate }}"
    >
      <i class="ri-stop-fill"></i>
    </button>
    <button
      data-cy="video-play"
      id="btn-play"
      mat-icon-button
      class="btn"
      (click)="playPause()"
      matTooltip="{{ 'button.play_pause' | translate }}"
    >
      <i
        [ngClass]="{
          'ri-play-mini-fill': video.paused,
          'ri-pause-fill': !video.paused
        }"
      ></i>
    </button>

    <!-- Loop Control -->
    <button
      id="btn-loop"
      mat-icon-button
      class="btn"
      (click)="toggleLoop()"
      matTooltip="Toggle Loop"
      [ngClass]="{ 'active-loop': video.loop }"
    >
      <i class="ri-infinity-line"></i>
    </button>

    <!-- Dropdown for Speed Selection -->
    <div class="dropdown">
      <button
        id="btn-speed"
        mat-icon-button
        class="btn"
        matTooltip="Playback Speed"
        (click)="toggleSpeedDropdown()"
      >
        <span>{{ playbackSpeed }}x</span>
      </button>
      <div class="dropdown-menu" [class.show]="speedDropdownOpen">
        <a class="dropdown-item" (click)="setPlaybackSpeed(0.5)">0.5x</a>
        <a class="dropdown-item" (click)="setPlaybackSpeed(1)">1x</a>
        <a class="dropdown-item" (click)="setPlaybackSpeed(1.5)">1.5x</a>
        <a class="dropdown-item" (click)="setPlaybackSpeed(2)">2x</a>
      </div>
    </div>

    <div id="videoBarDiv">
      <div class="reference-timeline">
        <div
          class="timeline-markers"
          style="margin-left: 10px; margin-right: 10px"
        >
          <span
            *ngFor="
              let marker of getTimelineMarkers(videoDuration);
              let i = index
            "
            [style.left]="marker.position + '%'"
          >
            | {{ marker.time }}
          </span>
        </div>
      </div>
      <div class="videoProgress" #trackbar (click)="progressBarClicked($event)">
        <div class="videoProgressLine">
          <div
            class="videoProgressLineFilled"
            [style.width]="relativeTime() + '%'"
          ></div>
        </div>
        <div
          class="videoTracker"
          id="tracker"
          #tracker
          [ngClass]="{ slow: slowSeek | async }"
        ></div>
        <ng-content selector="[progressBarItem]"></ng-content>
      </div>
    </div>
    <span id="label-time">
      <span
        class="label-video-index"
        *ngIf="selectedIndex + 1 as index"
        [matTooltip]="
          'tooltip.playing_video_x_of_n'
            | translate : { i: index, n: playListCount }
        "
        >[{{ index }}]</span
      >
      {{ videoCurrentTime | duration }} / {{ videoDuration | duration }}
    </span>
    <button
      id="btn-previous"
      mat-icon-button
      class="btn"
      matTooltip="{{ 'button.previous_video' | translate }}"
      [disabled]="selectedIndex === 0"
      (click)="selectVideo(selectedIndex - 1)"
    >
      <i class="ri-skip-back-fill"></i>
    </button>
    <button
      id="btn-next"
      mat-icon-button
      class="btn"
      matTooltip="{{ 'button.next_video' | translate }}"
      [disabled]="selectedIndex >= playListCount - 1"
      (click)="selectVideo(selectedIndex + 1)"
    >
      <i class="ri-skip-forward-fill"></i>
    </button>
    <button
      id="btn-select-video"
      mat-icon-button
      class="btn"
      matTooltip="{{ 'button.select_video' | translate }}"
      [disabled]="playListCount <= 1"
      (click)="toggleVideoSelectionOverlay()"
      data-cy="button-select-video"
    >
      <i
        class="ri-film-line"
        [class.text-primary]="showVideoSelectionOverlay$ | async"
        [matBadge]="playListCount > 1 ? playListCount : null"
        matBadgeSize="small"
      ></i>
    </button>
    <div id="resizeHandle" #resizeHandle></div>
  </div>
</div>

<div *ngIf="isLoading" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
